
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireada9"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireada9"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("es6JP", function(module, exports) {

$parcel$export(module.exports, "mount", () => $a858e84837df2a2c$export$186d02efde07ef98);
$parcel$export(module.exports, "unmount", () => $a858e84837df2a2c$export$121e2d597d222bad);
$parcel$export(module.exports, "registerDirective", () => $a858e84837df2a2c$export$bb39ea162039bcd5);
$parcel$export(module.exports, "jsx", () => $a858e84837df2a2c$export$34b9dba7ce09269b);
$parcel$export(module.exports, "setRef", () => $a858e84837df2a2c$export$4bb192c7cacf928f);
$parcel$export(module.exports, "jsxs", () => $a858e84837df2a2c$export$25062201e9e25d76);
$parcel$export(module.exports, "jsxRef", () => $a858e84837df2a2c$export$13f6ee1f6c622ff7);
$parcel$export(module.exports, "Fragment", () => $a858e84837df2a2c$export$ffb0004e005737fa);

var $cR8Yz = parcelRequire("cR8Yz");

var $2BOdQ = parcelRequire("2BOdQ");

var $a0KqP = parcelRequire("a0KqP");

var $7hKUk = parcelRequire("7hKUk");
const $a858e84837df2a2c$export$45118db60eed6f35 = (n)=>!!n?.[Symbol.metadata]?.[0, $7hKUk.$], $a858e84837df2a2c$export$186d02efde07ef98 = (n, t)=>n((0, $7hKUk.j)(t) ? (0, $2BOdQ.appendChild)(t) : t), $a858e84837df2a2c$export$185802fd694ee1f5 = (n)=>{
    const t = (0, $2BOdQ.fragment)();
    return $a858e84837df2a2c$export$186d02efde07ef98(n, t), 1 === t.childNodes.length ? t.firstChild : t;
}, $a858e84837df2a2c$export$121e2d597d222bad = (n)=>{
    const [t, , e] = n;
    t(), (0, $2BOdQ.removeRange)(e);
}, $a858e84837df2a2c$var$L = (t, r)=>{
    if ((0, $7hKUk.j)(t)) return r(t), $7hKUk.n;
    if ((0, $7hKUk.g)(t) && !(0, $cR8Yz.isSubscribable)(t)) return $a858e84837df2a2c$export$186d02efde07ef98(t, r)[0];
    if ((0, $7hKUk.o)(t)) {
        const n = [];
        return (0, $7hKUk.f)(t, (t)=>(0, $7hKUk.k)(n, $a858e84837df2a2c$var$L(t, r))), (0, $7hKUk.h)(n);
    }
    return (0, $cR8Yz.$text)`${t}`(r);
}, $a858e84837df2a2c$var$N = (n, t)=>{
    let e = null, r = null;
    const s = [];
    return (0, $7hKUk.k)(s, $a858e84837df2a2c$var$L(n, (n)=>{
        const s = (0, $7hKUk.q)(n);
        return e || (e = s ? n.firstChild : n), r = s ? n.lastChild : n, t(n);
    })), [
        s,
        ()=>e && r ? [
                e,
                r
            ] : void 0
    ];
}, $a858e84837df2a2c$var$P = (n, t)=>{
    const e = [];
    (0, $a0KqP.enterEffectScope)(e);
    const r = n(t);
    return (0, $a0KqP.quitEffectScope)(), (n)=>{
        const t = $a858e84837df2a2c$export$186d02efde07ef98(r, n), [s, ...o] = t, i = [];
        return (0, $7hKUk.k)(i, s), (0, $7hKUk.f)(e, (n)=>{
            const t = n();
            t && (0, $7hKUk.p)(i, t);
        }), [
            (0, $7hKUk.h)(i),
            ...o
        ];
    };
};
let $a858e84837df2a2c$var$R = (0, $2BOdQ.element);
const $a858e84837df2a2c$var$S = {}, $a858e84837df2a2c$var$W = {}, $a858e84837df2a2c$export$bb39ea162039bcd5 = (n)=>{
    const { prefix: t } = n;
    return n.requireParams || ($a858e84837df2a2c$var$S[t] = n), $a858e84837df2a2c$var$W[t] = n, ()=>{
        delete $a858e84837df2a2c$var$S[t], delete $a858e84837df2a2c$var$W[t];
    };
}, $a858e84837df2a2c$export$34b9dba7ce09269b = (e, r, ...s)=>{
    if (r ??= {}, s.length && (r.children = 1 === s.length ? s[0] : s), "string" == typeof e) return (s)=>{
        let a = $a858e84837df2a2c$var$R;
        const u = "svg" === e, m = "foreignObject" === e, j = "math" === e, w = u || m || j, { children: C, ref: x, ...k } = r;
        let q;
        u && ($a858e84837df2a2c$var$R = (0, $2BOdQ.svg)), j && ($a858e84837df2a2c$var$R = (0, $2BOdQ.mathml)), m && ($a858e84837df2a2c$var$R = (0, $2BOdQ.element)), (0, $7hKUk.i)(x) ? q = x : (q = $a858e84837df2a2c$var$R(e, "is" in r && (0, $7hKUk.e)(r.is) ? {
            is: r.is
        } : void 0), x && $a858e84837df2a2c$export$4bb192c7cacf928f(x, q));
        const [E] = null != C ? $a858e84837df2a2c$var$N(C, (0, $2BOdQ.appendChild)(q)) : [
            []
        ];
        for(const e in k){
            const r = k[e];
            let s = $a858e84837df2a2c$var$S[e], i = null;
            if (!s) {
                const n = e.indexOf(":");
                if (n > 0) {
                    const t = e.slice(0, n);
                    s = $a858e84837df2a2c$var$W[t], s && (i = e.slice(n + 1));
                }
            }
            if (s) {
                const n = s.apply(q, i, r);
                n && (0, $7hKUk.p)(E, n);
            } else if ((0, $cR8Yz.isSubscribable)(r)) (0, $7hKUk.p)(E, (0, $cR8Yz.$attr)(q, e, r));
            else {
                if (e.startsWith("on")) {
                    const n = e[2];
                    if ("A" <= n && n <= "Z") {
                        const n = e.slice(2).toLowerCase();
                        if ((0, $7hKUk.g)(r)) {
                            (0, $7hKUk.p)(E, (0, $7hKUk._)(q, n, r));
                            continue;
                        }
                        if ((0, $7hKUk.m)(O = r) && "handleEvent" in O && (0, $7hKUk.g)(O.handleEvent)) {
                            (0, $7hKUk.p)(E, (0, $7hKUk._)(q, n, r, r.options));
                            continue;
                        }
                    }
                }
                (0, $2BOdQ.attr)(q, e, r);
            }
        }
        var O;
        return s(q), w && ($a858e84837df2a2c$var$R = a), [
            (0, $7hKUk.h)(E),
            q,
            ()=>[
                    q,
                    q
                ]
        ];
    };
    if ($a858e84837df2a2c$export$45118db60eed6f35(e)) return (n)=>new e(r).mount(n);
    if (e.customRef) return $a858e84837df2a2c$var$P(e, r);
    const { ref: a, ...u } = r, m = $a858e84837df2a2c$var$P(e, u);
    return a ? (n)=>{
        const t = $a858e84837df2a2c$export$186d02efde07ef98(m, n);
        return $a858e84837df2a2c$export$4bb192c7cacf928f(a, t[1]), t;
    } : m;
}, $a858e84837df2a2c$export$25062201e9e25d76 = $a858e84837df2a2c$export$34b9dba7ce09269b, $a858e84837df2a2c$export$dda1d9f60106f0e9 = $a858e84837df2a2c$export$34b9dba7ce09269b, $a858e84837df2a2c$export$c8a8987d4410bf2d = $a858e84837df2a2c$export$34b9dba7ce09269b, $a858e84837df2a2c$export$13f6ee1f6c622ff7 = ()=>({
        current: null
    }), $a858e84837df2a2c$export$4bb192c7cacf928f = (n, t)=>{
    n.current = t;
}, $a858e84837df2a2c$export$ffb0004e005737fa = ({ children: n })=>(t)=>{
        const e = (0, $2BOdQ.fragment)(), [s, o] = n ? $a858e84837df2a2c$var$N(n, (0, $2BOdQ.appendChild)(e)) : [
            [],
            (0, $7hKUk.n)
        ];
        return t(e), [
            (0, $7hKUk.h)(s),
            void 0,
            o
        ];
    };

});
parcelRegister("cR8Yz", function(module, exports) {

$parcel$export(module.exports, "subscribe", () => $95c165b4e2a24160$export$ec068583843480e7);
$parcel$export(module.exports, "isSubscribable", () => $95c165b4e2a24160$export$afa9d06a32b253a4);
$parcel$export(module.exports, "isWritable", () => $95c165b4e2a24160$export$cc2b2f0230460456);
$parcel$export(module.exports, "configureBinding", () => $95c165b4e2a24160$export$62343fc05d20946e);
$parcel$export(module.exports, "$text", () => $95c165b4e2a24160$export$68028ad1cb93a754);
$parcel$export(module.exports, "$attr", () => $95c165b4e2a24160$export$2020da9baeb580d2);
$parcel$export(module.exports, "$class", () => $95c165b4e2a24160$export$dcd5e058b8249988);
$parcel$export(module.exports, "$style", () => $95c165b4e2a24160$export$2569a573ed0a661b);
$parcel$export(module.exports, "$var", () => $95c165b4e2a24160$export$fb1263f5e78aa11b);
$parcel$export(module.exports, "$model", () => $95c165b4e2a24160$export$5d47105054d22508);

var $2BOdQ = parcelRequire("2BOdQ");

var $7hKUk = parcelRequire("7hKUk");
const $95c165b4e2a24160$var$h = (t, e)=>(0, $7hKUk.n);
let $95c165b4e2a24160$export$ec068583843480e7 = $95c165b4e2a24160$var$h;
const $95c165b4e2a24160$var$f = (t)=>(0, $7hKUk.m)(t);
let $95c165b4e2a24160$export$afa9d06a32b253a4 = $95c165b4e2a24160$var$f;
const $95c165b4e2a24160$var$d = (t, e)=>{};
let $95c165b4e2a24160$export$635e15bbd66f01ea = $95c165b4e2a24160$var$d;
const $95c165b4e2a24160$var$b = (t)=>(0, $7hKUk.m)(t);
let $95c165b4e2a24160$export$cc2b2f0230460456 = $95c165b4e2a24160$var$b;
const $95c165b4e2a24160$export$62343fc05d20946e = (t, e, s, n)=>{
    $95c165b4e2a24160$export$ec068583843480e7 = t, $95c165b4e2a24160$export$afa9d06a32b253a4 = e, $95c165b4e2a24160$export$635e15bbd66f01ea = s, $95c165b4e2a24160$export$cc2b2f0230460456 = n;
}, $95c165b4e2a24160$export$f471722fe1d150c3 = ()=>{
    $95c165b4e2a24160$export$ec068583843480e7 = $95c165b4e2a24160$var$h, $95c165b4e2a24160$export$afa9d06a32b253a4 = $95c165b4e2a24160$var$f, $95c165b4e2a24160$export$635e15bbd66f01ea = $95c165b4e2a24160$var$d, $95c165b4e2a24160$export$cc2b2f0230460456 = $95c165b4e2a24160$var$b;
}, $95c165b4e2a24160$export$27adafa99d6409e = (e, s)=>$95c165b4e2a24160$export$ec068583843480e7(s, (s)=>(0, $2BOdQ.content)(e, s)), $95c165b4e2a24160$export$68028ad1cb93a754 = (t, ...s)=>{
    const n = s.length;
    return (r)=>{
        const o = [], i = [], u = ()=>{
            const t = i.join("");
            if (t) {
                const s = (0, $2BOdQ.text)(t);
                r(s);
            }
            i.length = 0;
        };
        for(let c = 0; c < n; c++){
            (0, $7hKUk.p)(i, t[c]);
            const n = s[c];
            if ($95c165b4e2a24160$export$afa9d06a32b253a4(n)) {
                u();
                const t = (0, $2BOdQ.text)("");
                (0, $7hKUk.p)(o, $95c165b4e2a24160$export$ec068583843480e7(n, (e)=>t.data = `${e}`)), r(t);
            } else (0, $7hKUk.p)(i, `${n}`);
        }
        return (0, $7hKUk.p)(i, t.at(-1)), u(), (0, $7hKUk.h)(o);
    };
}, $95c165b4e2a24160$export$2020da9baeb580d2 = (t, e, n)=>$95c165b4e2a24160$export$ec068583843480e7(n, (n)=>(0, $2BOdQ.attr)(t, e, n)), $95c165b4e2a24160$export$dcd5e058b8249988 = (t, e, s)=>$95c165b4e2a24160$export$ec068583843480e7(s, (s)=>(0, $2BOdQ.className)(t, e, s)), $95c165b4e2a24160$export$2569a573ed0a661b = (t, e, s)=>$95c165b4e2a24160$export$ec068583843480e7(s, (s)=>(0, $2BOdQ.style)(t, e, s)), $95c165b4e2a24160$export$fb1263f5e78aa11b = (t, e, s)=>$95c165b4e2a24160$export$ec068583843480e7(s, (s)=>(0, $2BOdQ.cssVar)(t, e, s)), $95c165b4e2a24160$var$D = (0, $7hKUk.t)(HTMLInputElement), $95c165b4e2a24160$var$H = {
    string: "value",
    boolean: "checked",
    number: "valueAsNumber",
    date: "valueAsDate"
}, $95c165b4e2a24160$var$I = {
    as: "string",
    on: "input"
}, $95c165b4e2a24160$var$L = {
    on: "change"
}, $95c165b4e2a24160$var$M = "value";
class $95c165b4e2a24160$var$T {
    #t;
    #e;
    constructor(t, e){
        this.#t = t, this.#e = e;
    }
    handleEvent(t) {
        const e = t.target;
        this.#e ? $95c165b4e2a24160$export$635e15bbd66f01ea(this.#t, e[this.#e]) : $95c165b4e2a24160$export$635e15bbd66f01ea(this.#t, e.value);
    }
}
const $95c165b4e2a24160$export$5d47105054d22508 = (t, e, s)=>{
    const n = $95c165b4e2a24160$var$D(t), r = n ? {
        ...$95c165b4e2a24160$var$I,
        ...s
    } : {
        ...$95c165b4e2a24160$var$L,
        ...s
    }, { as: o, on: a } = r, c = n ? $95c165b4e2a24160$var$H[o] ?? $95c165b4e2a24160$var$M : $95c165b4e2a24160$var$M, u = n && "radio" === t.type, l = $95c165b4e2a24160$export$ec068583843480e7(e, u ? (e)=>{
        t.checked = e === t.value;
    } : (e)=>{
        if (n && "number" === o) {
            if (isNaN(e)) return void (t.value = "");
            if (e === t[c]) return;
        }
        t[c] = e;
    }), p = (0, $7hKUk._)(t, a, new $95c165b4e2a24160$var$T(e, n && c));
    return ()=>{
        p(), l();
    };
};

});
parcelRegister("2BOdQ", function(module, exports) {

$parcel$export(module.exports, "element", () => $1e65fe9220d4f801$export$8454457683f90105);
$parcel$export(module.exports, "text", () => $1e65fe9220d4f801$export$6f093cfa640b7166);
$parcel$export(module.exports, "svg", () => $1e65fe9220d4f801$export$7ed1367e7fa1ad68);
$parcel$export(module.exports, "mathml", () => $1e65fe9220d4f801$export$47d5b44d225be5b4);
$parcel$export(module.exports, "fragment", () => $1e65fe9220d4f801$export$f00aeb236b6f05af);
$parcel$export(module.exports, "clone", () => $1e65fe9220d4f801$export$9cd59f9826255e47);
$parcel$export(module.exports, "attr", () => $1e65fe9220d4f801$export$7aabe8b3a840d2fd);
$parcel$export(module.exports, "content", () => $1e65fe9220d4f801$export$a7db06668cad9adb);
$parcel$export(module.exports, "className", () => $1e65fe9220d4f801$export$2913c0c0b5623090);
$parcel$export(module.exports, "style", () => $1e65fe9220d4f801$export$1d567c320f4763bc);
$parcel$export(module.exports, "cssVar", () => $1e65fe9220d4f801$export$8b4981022bd80a4e);
$parcel$export(module.exports, "listen", () => $1e65fe9220d4f801$export$63174c828edd6ff8);
$parcel$export(module.exports, "appendChild", () => $1e65fe9220d4f801$export$1b8e57c9ea42f1d2);
$parcel$export(module.exports, "before", () => $1e65fe9220d4f801$export$1c4c1e3098bf5ebe);
$parcel$export(module.exports, "moveRange", () => $1e65fe9220d4f801$export$71fab7eb76d05d5a);
$parcel$export(module.exports, "removeRange", () => $1e65fe9220d4f801$export$df89bc4a93f2927c);

var $7hKUk = parcelRequire("7hKUk");
const $1e65fe9220d4f801$export$8454457683f90105 = (0, $7hKUk.d).createElement.bind((0, $7hKUk.d)), $1e65fe9220d4f801$export$6f093cfa640b7166 = (0, $7hKUk.d).createTextNode.bind((0, $7hKUk.d)), $1e65fe9220d4f801$export$7ed1367e7fa1ad68 = (t)=>(0, $7hKUk.d).createElementNS("http://www.w3.org/2000/svg", t), $1e65fe9220d4f801$export$47d5b44d225be5b4 = (t)=>(0, $7hKUk.d).createElementNS("http://www.w3.org/1998/Math/MathML", t), $1e65fe9220d4f801$export$f00aeb236b6f05af = (0, $7hKUk.d).createDocumentFragment.bind((0, $7hKUk.d)), $1e65fe9220d4f801$export$9cd59f9826255e47 = (e)=>e.cloneNode(!0), $1e65fe9220d4f801$export$7aabe8b3a840d2fd = (e, t, r)=>null == r || !1 === r ? e.removeAttribute(t) : e.setAttribute(t, `${r}`), $1e65fe9220d4f801$export$a7db06668cad9adb = (e, t)=>e.textContent = `${t}`, $1e65fe9220d4f801$export$2913c0c0b5623090 = (e, t, r)=>e.classList.toggle(t, r), $1e65fe9220d4f801$export$1d567c320f4763bc = (e, t, r)=>{
    const n = e.style;
    t in n ? n[t] = r : n.setProperty(t, r);
}, $1e65fe9220d4f801$export$8b4981022bd80a4e = (e, t, r)=>{
    const n = `--${t}`;
    e.style.setProperty(n, r);
}, $1e65fe9220d4f801$export$3d8c2f653ac9d0b9 = (0, $7hKUk.d).querySelector.bind((0, $7hKUk.d)), $1e65fe9220d4f801$export$fe324b23443c13e2 = (r)=>(0, $7hKUk.a)((0, $7hKUk.d).querySelectorAll(r)), $1e65fe9220d4f801$export$63174c828edd6ff8 = (e)=>(t, n, o)=>(0, $7hKUk._)(e, t, n, o), $1e65fe9220d4f801$export$10b1921597150314 = (e)=>(t, r)=>(0, $7hKUk.b)(e, t, r), $1e65fe9220d4f801$export$1b8e57c9ea42f1d2 = (e)=>(t)=>e.appendChild(t), $1e65fe9220d4f801$export$1c4c1e3098bf5ebe = (e)=>(t)=>e.parentNode.insertBefore(t, e), $1e65fe9220d4f801$export$742acabee3dd6465 = (e)=>(t)=>e.after(t), $1e65fe9220d4f801$export$4cd63e4f35485b12 = (e)=>{
    const t = (0, $7hKUk.c)(), r = (0, $7hKUk.c)(), n = $1e65fe9220d4f801$export$742acabee3dd6465(e);
    return n(t), n(r), $1e65fe9220d4f801$export$1c4c1e3098bf5ebe(r);
}, $1e65fe9220d4f801$export$cd7f480d6b8286c3 = (e)=>e.parentNode?.removeChild(e), $1e65fe9220d4f801$export$71fab7eb76d05d5a = (e, t, r)=>{
    const n = [];
    for(let r = e; r && r !== t; r = r.nextSibling)(0, $7hKUk.p)(n, r);
    t && (0, $7hKUk.p)(n, t), (0, $7hKUk.f)(n, r);
}, $1e65fe9220d4f801$export$df89bc4a93f2927c = (e)=>{
    const t = e();
    t && $1e65fe9220d4f801$export$71fab7eb76d05d5a(t[0], t[1], $1e65fe9220d4f801$export$cd7f480d6b8286c3);
}, $1e65fe9220d4f801$export$9bb0e144ba4929ca = (e, t)=>{
    for(let r = 0, n = t.length; r < n && (e = e.children[t[r]]); r++);
    return e;
};

});
parcelRegister("7hKUk", function(module, exports) {

$parcel$export(module.exports, "v", () => $54de81d12ee6433b$export$90a7f3efeed30595);
$parcel$export(module.exports, "s", () => $54de81d12ee6433b$export$2408f22a0fab9ae5);
$parcel$export(module.exports, "p", () => $54de81d12ee6433b$export$ffb5f4729a158638);
$parcel$export(module.exports, "a", () => $54de81d12ee6433b$export$407448d2b89b1813);
$parcel$export(module.exports, "n", () => $54de81d12ee6433b$export$7ccc53e8f1e7dfc5);
$parcel$export(module.exports, "y", () => $54de81d12ee6433b$export$4a5767248b18ef41);
$parcel$export(module.exports, "h", () => $54de81d12ee6433b$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "e", () => $54de81d12ee6433b$export$f1e1789686576879);
$parcel$export(module.exports, "g", () => $54de81d12ee6433b$export$39b482c5e57630a8);
$parcel$export(module.exports, "m", () => $54de81d12ee6433b$export$953cecd6e717a553);
$parcel$export(module.exports, "o", () => $54de81d12ee6433b$export$ae1af26003f05816);
$parcel$export(module.exports, "t", () => $54de81d12ee6433b$export$625550452a3fa3ec);
$parcel$export(module.exports, "u", () => $54de81d12ee6433b$export$3b14a55fb2447963);
$parcel$export(module.exports, "r", () => $54de81d12ee6433b$export$43caf9889c228507);
$parcel$export(module.exports, "f", () => $54de81d12ee6433b$export$2d1720544b23b823);
$parcel$export(module.exports, "d", () => $54de81d12ee6433b$export$4368d992c4eafac0);
$parcel$export(module.exports, "c", () => $54de81d12ee6433b$export$db3b6bfb95261072);
$parcel$export(module.exports, "w", () => $54de81d12ee6433b$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "k", () => $54de81d12ee6433b$export$342063e11d6c3cad);
$parcel$export(module.exports, "_", () => $54de81d12ee6433b$export$71511d61b312f219);
$parcel$export(module.exports, "b", () => $54de81d12ee6433b$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "j", () => $54de81d12ee6433b$export$35e795649ee09318);
$parcel$export(module.exports, "q", () => $54de81d12ee6433b$export$9e5f44173e64f162);
$parcel$export(module.exports, "i", () => $54de81d12ee6433b$export$23f2a1d2818174ef);
$parcel$export(module.exports, "C", () => $54de81d12ee6433b$export$e7094788287c5e9b);
$parcel$export(module.exports, "x", () => $54de81d12ee6433b$export$d141bba7fdc215a3);
$parcel$export(module.exports, "z", () => $54de81d12ee6433b$export$df995fae86a55f06);
$parcel$export(module.exports, "$", () => $54de81d12ee6433b$export$3d8c2f653ac9d0b9);
$parcel$export(module.exports, "l", () => $54de81d12ee6433b$export$882b5998b3b9117c);
const $54de81d12ee6433b$export$90a7f3efeed30595 = Object.assign, $54de81d12ee6433b$export$ef35774e6d314e91 = (e)=>{
    let t, s = !1;
    return ()=>s ? t : (s = !0, t = e());
}, $54de81d12ee6433b$export$2408f22a0fab9ae5 = ()=>{
    const e = [];
    return [
        (t)=>$54de81d12ee6433b$export$ffb5f4729a158638(e, t),
        ()=>{
            $54de81d12ee6433b$var$o(e);
        },
        ()=>e.at(-1)
    ];
}, $54de81d12ee6433b$export$407448d2b89b1813 = Array.from, $54de81d12ee6433b$export$ffb5f4729a158638 = (e, t)=>e.push(t), $54de81d12ee6433b$var$o = (e)=>e.pop(), $54de81d12ee6433b$export$7ccc53e8f1e7dfc5 = ()=>{}, $54de81d12ee6433b$export$4a5767248b18ef41 = (e)=>{
    for(let t = e.length - 1; t >= 0; t--)e[t]();
}, $54de81d12ee6433b$export$dda1d9f60106f0e9 = (e)=>e.length ? ()=>$54de81d12ee6433b$export$4a5767248b18ef41(e) : $54de81d12ee6433b$export$7ccc53e8f1e7dfc5, $54de81d12ee6433b$export$f1e1789686576879 = (e)=>"string" == typeof e, $54de81d12ee6433b$export$39b482c5e57630a8 = (e)=>"function" == typeof e, $54de81d12ee6433b$export$953cecd6e717a553 = (e)=>null != e && "object" == typeof e, $54de81d12ee6433b$export$ae1af26003f05816 = Array.isArray, $54de81d12ee6433b$export$625550452a3fa3ec = (e)=>(t)=>t instanceof e, $54de81d12ee6433b$export$96f57966bedc81b4 = Object.is, $54de81d12ee6433b$export$3b14a55fb2447963 = Object.defineProperty, $54de81d12ee6433b$export$43caf9889c228507 = Object.is, $54de81d12ee6433b$export$2d1720544b23b823 = (e, t)=>{
    for(let s = 0, a = e.length; s < a; s++)t(e[s]);
}, $54de81d12ee6433b$export$4368d992c4eafac0 = document, $54de81d12ee6433b$export$db3b6bfb95261072 = (e)=>$54de81d12ee6433b$export$4368d992c4eafac0.createComment(""), $54de81d12ee6433b$export$efccba1c4a2ef57b = (e)=>{
    const t = $54de81d12ee6433b$export$db3b6bfb95261072(), s = $54de81d12ee6433b$export$db3b6bfb95261072();
    return [
        t,
        s,
        ()=>{
            for(let n = t.nextSibling, w = n; n && n !== s; n = w){
                w = n.nextSibling;
                n.parentNode.removeChild(n);
            }
        }
    ];
}, $54de81d12ee6433b$export$342063e11d6c3cad = (e, t)=>{
    t !== $54de81d12ee6433b$export$7ccc53e8f1e7dfc5 && $54de81d12ee6433b$export$ffb5f4729a158638(e, t);
}, $54de81d12ee6433b$export$71511d61b312f219 = (e, t, s, a)=>(e.addEventListener(t, s, a), ()=>{
        e.removeEventListener(t, s, a);
    }), $54de81d12ee6433b$export$8b22cf2602fb60ce = (e, t, s)=>{
    const a = e.ownerDocument, n = a.$$delegates ??= new Set();
    n.has(t) || (n.add(t), a.addEventListener(t, $54de81d12ee6433b$var$w));
    const o = `_$${t}`;
    return e[o] = s, ()=>{
        delete e[o];
    };
}, $54de81d12ee6433b$var$w = (e)=>{
    const t = `_$${e.type}`, s = e.composedPath();
    $54de81d12ee6433b$export$2d1720544b23b823(s, (s)=>{
        const a = s[t];
        if (null != a) try {
            a.call(s, e);
        } catch (e) {
            ((e)=>{
                const t = e instanceof Error ? `stack trace: \n${e.stack}` : JSON.stringify(e);
                console.error(`[ERROR]: ${t}`);
            })(e);
        }
    });
}, $54de81d12ee6433b$export$35e795649ee09318 = $54de81d12ee6433b$export$625550452a3fa3ec(Node), $54de81d12ee6433b$export$9e5f44173e64f162 = $54de81d12ee6433b$export$625550452a3fa3ec(DocumentFragment), $54de81d12ee6433b$export$ebd11618f299a286 = $54de81d12ee6433b$export$625550452a3fa3ec(HTMLTemplateElement), $54de81d12ee6433b$var$L = $54de81d12ee6433b$export$625550452a3fa3ec(Text), $54de81d12ee6433b$export$23f2a1d2818174ef = $54de81d12ee6433b$export$625550452a3fa3ec(Element), $54de81d12ee6433b$export$e7094788287c5e9b = (e)=>$54de81d12ee6433b$var$L(e) || $54de81d12ee6433b$export$23f2a1d2818174ef(e), $54de81d12ee6433b$export$d141bba7fdc215a3 = new Proxy({}, {
    get: (e, t)=>t
}), $54de81d12ee6433b$export$df995fae86a55f06 = Symbol.for("hyplate-signal"), $54de81d12ee6433b$export$3d8c2f653ac9d0b9 = Symbol.for("hyplate-element-meta"), $54de81d12ee6433b$export$882b5998b3b9117c = (e)=>e[$54de81d12ee6433b$export$3d8c2f653ac9d0b9] ??= {};

});



parcelRegister("a0KqP", function(module, exports) {

$parcel$export(module.exports, "enterEffectScope", () => $749debdaabd19d69$export$407c9697ea33ec65);
$parcel$export(module.exports, "quitEffectScope", () => $749debdaabd19d69$export$e9c2b9b864f1f183);
$parcel$export(module.exports, "useEffect", () => $749debdaabd19d69$export$6d9c69b0de29b591);

var $7hKUk = parcelRequire("7hKUk");
const [$749debdaabd19d69$export$2d8959f088e46cf6, $749debdaabd19d69$export$eb6076592e119c85, $749debdaabd19d69$export$241d797c2bd1630] = (0, $7hKUk.s)(), $749debdaabd19d69$var$a = ()=>{
    let o = $749debdaabd19d69$export$241d797c2bd1630();
    if (!o) throw new Error("Invalid hook call. Hooks can only be called inside the setup function of template-based component.");
    return o;
}, $749debdaabd19d69$export$39c6a2b4dbabca5d = (o)=>{
    const n = (n)=>{
        (0, $7hKUk.k)(o, n);
    };
    return {
        useCleanUpCollector: ()=>n
    };
}, $749debdaabd19d69$export$b1ca6d36dd52569c = ()=>$749debdaabd19d69$var$a().useCleanUpCollector(), $749debdaabd19d69$export$830f4fe430b1285d = (o)=>(n)=>{
        const [e, t] = o(n);
        return $749debdaabd19d69$export$f665b0f2db230f5e(e), t;
    }, $749debdaabd19d69$export$f665b0f2db230f5e = (o)=>$749debdaabd19d69$var$a().useCleanUpCollector()(o), [$749debdaabd19d69$export$407c9697ea33ec65, $749debdaabd19d69$export$e9c2b9b864f1f183, $749debdaabd19d69$export$6847850a87255b2e] = (0, $7hKUk.s)(), $749debdaabd19d69$export$6d9c69b0de29b591 = (o)=>{
    const e = $749debdaabd19d69$export$6847850a87255b2e();
    if (!e) throw new Error("Invalid hook call. Current scope is not in a functional component.");
    (0, $7hKUk.p)(e, o);
};

});


parcelRegister("guLfS", function(module, exports) {

$parcel$export(module.exports, "Attribute", () => (parcelRequire("1iT6d")).Attribute);
$parcel$export(module.exports, "AutoRender", () => (parcelRequire("1iT6d")).AutoRender);
$parcel$export(module.exports, "useAutoRun", () => (parcelRequire("1iT6d")).useAutoRun);
$parcel$export(module.exports, "attr", () => (parcelRequire("2BOdQ")).attr);
$parcel$export(module.exports, "clone", () => (parcelRequire("2BOdQ")).clone);
$parcel$export(module.exports, "content", () => (parcelRequire("2BOdQ")).content);
$parcel$export(module.exports, "cssVar", () => (parcelRequire("2BOdQ")).cssVar);
$parcel$export(module.exports, "element", () => (parcelRequire("2BOdQ")).element);
$parcel$export(module.exports, "listen", () => (parcelRequire("2BOdQ")).listen);
$parcel$export(module.exports, "style", () => (parcelRequire("2BOdQ")).style);
$parcel$export(module.exports, "mount", () => (parcelRequire("es6JP")).mount);
$parcel$export(module.exports, "registerDirective", () => (parcelRequire("es6JP")).registerDirective);
$parcel$export(module.exports, "unmount", () => (parcelRequire("es6JP")).unmount);
$parcel$export(module.exports, "For", () => (parcelRequire("fnbPI")).For);
$parcel$export(module.exports, "Future", () => (parcelRequire("fnbPI")).Future);
$parcel$export(module.exports, "Show", () => (parcelRequire("fnbPI")).Show);
$parcel$export(module.exports, "nil", () => (parcelRequire("fnbPI")).nil);
$parcel$export(module.exports, "isSubscribable", () => (parcelRequire("cR8Yz")).isSubscribable);
$parcel$export(module.exports, "subscribe", () => (parcelRequire("cR8Yz")).subscribe);
$parcel$export(module.exports, "Component", () => (parcelRequire("auAVx")).Component);
$parcel$export(module.exports, "HyplateElement", () => (parcelRequire("auAVx")).HyplateElement);
$parcel$export(module.exports, "computed", () => (parcelRequire("duS9r")).computed);
$parcel$export(module.exports, "effect", () => (parcelRequire("duS9r")).effect);
$parcel$export(module.exports, "signal", () => (parcelRequire("duS9r")).signal);
$parcel$export(module.exports, "watch", () => (parcelRequire("duS9r")).watch);
$parcel$export(module.exports, "noop", () => (parcelRequire("7hKUk")).n);

var $1iT6d = parcelRequire("1iT6d");

var $2BOdQ = parcelRequire("2BOdQ");

var $es6JP = parcelRequire("es6JP");

var $fnbPI = parcelRequire("fnbPI");


var $cR8Yz = parcelRequire("cR8Yz");

var $auAVx = parcelRequire("auAVx");

var $duS9r = parcelRequire("duS9r");


var $7hKUk = parcelRequire("7hKUk");
parcelRequire("1rUBR");


});
parcelRegister("1iT6d", function(module, exports) {

$parcel$export(module.exports, "useAutoRun", () => $0f3236776e18b1f4$export$8b49f478d94e1fba);
$parcel$export(module.exports, "AutoRender", () => $0f3236776e18b1f4$export$375c0ccff4bd2d2d);
$parcel$export(module.exports, "Attribute", () => $0f3236776e18b1f4$export$ab9c25261cd8c720);
parcelRequire("1rUBR");

var $fnbPI = parcelRequire("fnbPI");

var $auAVx = parcelRequire("auAVx");

var $a0KqP = parcelRequire("a0KqP");

var $7hKUk = parcelRequire("7hKUk");

var $es6JP = parcelRequire("es6JP");

var $duS9r = parcelRequire("duS9r");



(0, $duS9r.enableBuiltinSignals)(), (0, $es6JP.registerDirective)(new (0, $fnbPI.EventDelegateDirective)), (0, $es6JP.registerDirective)(new (0, $fnbPI.ClassBindingDirective)), (0, $es6JP.registerDirective)(new (0, $fnbPI.StyleBindingDirective)), (0, $es6JP.registerDirective)(new (0, $fnbPI.CSSVariableBindingDirective)), (0, $es6JP.registerDirective)(new (0, $fnbPI.ModelDirective));
const $0f3236776e18b1f4$var$p = (0, $auAVx.HyplateElement).prototype;
$0f3236776e18b1f4$var$p.connectedCallback = function() {
    this.mount();
}, $0f3236776e18b1f4$var$p.disconnectedCallback = function() {
    this.unmount();
}, $0f3236776e18b1f4$var$p.attributeChangedCallback = function(t, e, n) {
    this[0, $7hKUk.$]?.attributes?.[t].set(n);
}, $0f3236776e18b1f4$var$p.autorun = function(t) {
    this.effect(()=>(0, $duS9r.effect)(t));
};
const $0f3236776e18b1f4$export$8b49f478d94e1fba = (t)=>(0, $a0KqP.useEffect)(()=>(0, $duS9r.effect)(t)), $0f3236776e18b1f4$var$j = (t)=>t, $0f3236776e18b1f4$export$375c0ccff4bd2d2d = ({ children: t })=>(0, $es6JP.jsx)((0, $fnbPI.Show), {
        when: (0, $duS9r.computed)(t),
        children: $0f3236776e18b1f4$var$j
    }), $0f3236776e18b1f4$export$ab9c25261cd8c720 = (t, e)=>(n, r)=>{
        const s = (0, $7hKUk.l)(r.metadata);
        function i(n) {
            const r = this[0, $7hKUk.$] ??= {}, s = r.attributes ??= {}, i = s[t] ??= (0, $duS9r.signal)(this.getAttribute(t));
            return e ? (0, $duS9r.computed)(()=>{
                const t = i();
                return null == t ? null : e(t);
            }) : i;
        }
        return (s.attributes ??= new Set).add(t), "field" === r.kind ? i : {
            init: i,
            set (t) {
                throw new Error("Cannot set binded attribute. It's read-only.");
            }
        };
    };

});
parcelRegister("1rUBR", function(module, exports) {
Symbol.metadata || Object.defineProperty(Symbol, "metadata", {
    value: Symbol("Symbol.metadata")
});

});

parcelRegister("fnbPI", function(module, exports) {

$parcel$export(module.exports, "nil", () => $b3122ecfa50d0f4a$export$f2c4f74e8fe88e34);
$parcel$export(module.exports, "Show", () => $b3122ecfa50d0f4a$export$f6a3d19be20f5819);
$parcel$export(module.exports, "Future", () => $b3122ecfa50d0f4a$export$c9d7bf589772a8ce);
$parcel$export(module.exports, "For", () => $b3122ecfa50d0f4a$export$bdf530073099ce9f);
$parcel$export(module.exports, "EventDelegateDirective", () => $b3122ecfa50d0f4a$export$6fa9558f30e94dfa);
$parcel$export(module.exports, "ClassBindingDirective", () => $b3122ecfa50d0f4a$export$e470f87baa20626a);
$parcel$export(module.exports, "StyleBindingDirective", () => $b3122ecfa50d0f4a$export$a2f939b68b73ad4d);
$parcel$export(module.exports, "CSSVariableBindingDirective", () => $b3122ecfa50d0f4a$export$3a8c9ee696810871);
$parcel$export(module.exports, "ModelDirective", () => $b3122ecfa50d0f4a$export$5183ef81bfee96a8);

var $7hKUk = parcelRequire("7hKUk");

var $2BOdQ = parcelRequire("2BOdQ");

var $cR8Yz = parcelRequire("cR8Yz");

var $es6JP = parcelRequire("es6JP");

const $b3122ecfa50d0f4a$var$v = (r, s, n, t)=>(o)=>{
        const l = s ?? (0, $es6JP.jsxRef)(), [i, c, u] = (0, $7hKUk.w)();
        o(i), o(c);
        const m = (0, $2BOdQ.before)(c);
        let p = null, h = null;
        const g = (0, $cR8Yz.subscribe)(r, (e)=>{
            p?.(), u(), e ? [p, h] = (0, $es6JP.mount)(n(e), m) : t ? [p, h] = (0, $es6JP.mount)(t(), m) : (p = null, h = null), (0, $es6JP.setRef)(l, h);
        });
        return [
            ()=>{
                g(), p?.();
            },
            l,
            ()=>[
                    i,
                    c
                ]
        ];
    }, $b3122ecfa50d0f4a$var$y = [
    (0, $7hKUk.n),
    void 0,
    (0, $7hKUk.n)
], $b3122ecfa50d0f4a$export$f2c4f74e8fe88e34 = ()=>$b3122ecfa50d0f4a$var$y, $b3122ecfa50d0f4a$export$1f9ff5f4a6c9361a = (e)=>$b3122ecfa50d0f4a$var$v(e.condition, e.ref, e.then, e.else);
$b3122ecfa50d0f4a$export$1f9ff5f4a6c9361a.customRef = !0;
const $b3122ecfa50d0f4a$export$f6a3d19be20f5819 = ({ when: e, ref: r, children: s, fallback: n })=>$b3122ecfa50d0f4a$var$v(e, r, s, n);
$b3122ecfa50d0f4a$export$f6a3d19be20f5819.customRef = !0;
const $b3122ecfa50d0f4a$export$c9d7bf589772a8ce = ({ promise: r, ref: s, children: n, fallback: t, error: o })=>(l)=>{
        const i = s ?? (0, $es6JP.jsxRef)(), [c, a, u] = (0, $7hKUk.w)();
        l(c), l(a);
        const m = (0, $2BOdQ.before)(a);
        let p = null, h = null;
        const g = r.then((e)=>{
            t && u(), [p, h] = (0, $es6JP.mount)(n(e), m), (0, $es6JP.setRef)(i, h);
        });
        return t && ([p, h] = (0, $es6JP.mount)(t, m), (0, $es6JP.setRef)(i, h)), o && g.catch((e)=>{
            [p, h] = (0, $es6JP.mount)(o(e), m), (0, $es6JP.setRef)(i, h);
        }), [
            ()=>{
                p?.();
            },
            i,
            ()=>[
                    c,
                    a
                ]
        ];
    };
$b3122ecfa50d0f4a$export$c9d7bf589772a8ce.customRef = !0;
const $b3122ecfa50d0f4a$var$M = (e)=>{
    const r = e[1];
    (0, $es6JP.unmount)(r);
}, $b3122ecfa50d0f4a$var$z = ()=>0, $b3122ecfa50d0f4a$export$bdf530073099ce9f = ({ of: n, children: t })=>(l)=>{
        let i = [];
        const [c, u, m] = (0, $7hKUk.w)();
        l(c), l(u);
        const p = (0, $cR8Yz.subscribe)(n, (e)=>{
            const n = [];
            for(let r = 0, s = e.length; r < s; r++)n.push([
                e[r],
                void 0
            ]);
            let l = 0;
            const c = n.length;
            let a = i.length - 1, m = c - 1;
            for(l = 0; l <= a && l <= m; l++){
                const e = i[l], s = n[l];
                if (!(0, $7hKUk.r)(e[0], s[0])) break;
                s[1] = e[1];
            }
            for(; l <= a && l <= m; a--, m--){
                const e = i[a], s = n[m];
                if (!(0, $7hKUk.r)(e[0], s[0])) break;
                s[1] = e[1];
            }
            if (l > a) {
                if (l <= m) {
                    const e = m + 1, r = n[e]?.[1][2]()?.[0] ?? u, s = (0, $2BOdQ.before)(r);
                    for(; l <= m; l++){
                        const e = n[l];
                        e[1] = (0, $es6JP.mount)(t(e[0]), s);
                    }
                }
            } else if (l > m) for(; l <= a; l++)$b3122ecfa50d0f4a$var$M(i[l]);
            else {
                const e = l, r = l, c = new Map;
                for(l = e; l <= m; l++){
                    const e = n[l][0];
                    c.set(e, l);
                }
                let p, h = 0;
                const g = m - r + 1;
                let d = !1, w = 0;
                const x = (0, $7hKUk.a)({
                    length: g
                }, $b3122ecfa50d0f4a$var$z);
                for(l = e; l <= a; l++){
                    const e = i[l];
                    if (h >= g) {
                        $b3122ecfa50d0f4a$var$M(e);
                        continue;
                    }
                    const s = c.get(e[0]);
                    null == s ? $b3122ecfa50d0f4a$var$M(e) : (x[s - r] = l + 1, s >= w ? w = s : d = !0, n[s][1] = e[1], h++);
                }
                const j = d ? $b3122ecfa50d0f4a$var$B(x) : [];
                for(p = j.length - 1, l = g - 1; l >= 0; l--){
                    const e = r + l, s = n[e], i = n[e + 1]?.[1][2]()?.[0] ?? u, c = (0, $2BOdQ.before)(i);
                    if (0 === x[l]) s[1] = (0, $es6JP.mount)(t(s[0]), c);
                    else if (d) {
                        if (p < 0 || l !== j[p]) {
                            const e = s[1][2]();
                            e && (0, $2BOdQ.moveRange)(e[0], e[1], c);
                        } else p--;
                    }
                }
            }
            i = n;
        });
        return [
            ()=>{
                for(let e = i.length - 1; e >= 0; e--)i[e][1][0]();
                p(), m();
            },
            void 0,
            ()=>[
                    c,
                    u
                ]
        ];
    }, $b3122ecfa50d0f4a$var$B = (e)=>{
    const r = [
        ...e
    ], s = [
        0
    ];
    let n, t, o, l, i;
    const c = e.length;
    for(n = 0; n < c; n++){
        const c = e[n];
        if (0 !== c) {
            if (t = s[s.length - 1], e[t] < c) {
                r[n] = t, s.push(n);
                continue;
            }
            for(o = 0, l = s.length - 1; o < l;)i = o + l >> 1, e[s[i]] < c ? o = i + 1 : l = i;
            c < e[s[o]] && (o > 0 && (r[n] = s[o - 1]), s[o] = n);
        }
    }
    for(o = s.length, l = s[o - 1]; o-- > 0;)s[o] = l, l = r[l];
    return s;
};
class $b3122ecfa50d0f4a$export$6fa9558f30e94dfa {
    prefix = "on";
    requireParams = !0;
    apply = (0, $7hKUk.b);
}
class $b3122ecfa50d0f4a$export$e470f87baa20626a {
    prefix = "class";
    requireParams = !0;
    apply(e, r, s) {
        if ((0, $cR8Yz.isSubscribable)(s)) return (0, $cR8Yz.$class)(e, r, s);
        (0, $2BOdQ.className)(e, r, s);
    }
}
class $b3122ecfa50d0f4a$export$a2f939b68b73ad4d {
    prefix = "style";
    requireParams = !0;
    apply(e, r, s) {
        if ((0, $cR8Yz.isSubscribable)(s)) return (0, $cR8Yz.$style)(e, r, s);
        (0, $2BOdQ.style)(e, r, s);
    }
}
class $b3122ecfa50d0f4a$export$3a8c9ee696810871 {
    prefix = "var";
    requireParams = !0;
    apply(e, r, s) {
        if ((0, $cR8Yz.isSubscribable)(s)) return (0, $cR8Yz.$var)(e, r, s);
        (0, $2BOdQ.cssVar)(e, r, s);
    }
}
class $b3122ecfa50d0f4a$export$5183ef81bfee96a8 {
    prefix = "h-model";
    requireParams = !1;
    apply(e, r, s) {
        if ((0, $cR8Yz.isWritable)(s)) {
            if (((e)=>"value" in e)(e)) return (0, $cR8Yz.$model)(e, s, r ? {
                as: r
            } : void 0);
        }
    }
}

});

parcelRegister("auAVx", function(module, exports) {

$parcel$export(module.exports, "Component", () => $7a3959ab53c63785$export$16fa2f45be04daa8);
$parcel$export(module.exports, "HyplateElement", () => $7a3959ab53c63785$export$ec2439515a3718b9);

var $cR8Yz = parcelRequire("cR8Yz");

var $2BOdQ = parcelRequire("2BOdQ");

var $7hKUk = parcelRequire("7hKUk");

var $es6JP = parcelRequire("es6JP");

var $d0FcS = parcelRequire("d0FcS");

const $7a3959ab53c63785$var$w = customElements, $7a3959ab53c63785$export$f36d6a7a5c09a23e = $7a3959ab53c63785$var$w.define.bind($7a3959ab53c63785$var$w), $7a3959ab53c63785$var$j = "observedAttributes", $7a3959ab53c63785$export$16fa2f45be04daa8 = (t)=>(s, e)=>{
        e.addInitializer(function() {
            const s = (0, $7hKUk.l)(e.metadata), o = this, { tag: a, [$7a3959ab53c63785$var$j]: h, ...c } = t;
            if (o.tag = a, !Object.hasOwn(o, $7a3959ab53c63785$var$j)) {
                if (h) (0, $7hKUk.u)(o, $7a3959ab53c63785$var$j, {
                    get: ()=>h
                });
                else {
                    const { attributes: t } = s;
                    t && (0, $7hKUk.u)(o, $7a3959ab53c63785$var$j, {
                        get: ()=>[
                                ...t
                            ]
                    });
                }
            }
            (0, $7hKUk.v)(o, c), $7a3959ab53c63785$export$f36d6a7a5c09a23e(a, o);
        });
    }, $7a3959ab53c63785$export$ec2439515a3718b9 = class extends HTMLElement {
    static [(0, $7hKUk.$)] = {};
    static shadowRootInit = {};
    static tag;
    static get slotTag() {
        return (0, $d0FcS.s)(this.tag);
    }
    static styles = [];
    static get observedAttributes() {
        return [];
    }
    static formAssociated;
    props;
    slots = (0, $7hKUk.x);
    cleanups = [];
    #t;
    #s;
    #e = null;
    #i;
    constructor(t){
        super(), this.#i = new.target, this.setup(t);
    }
    setup(i) {
        let n, r;
        const o = {}, { cleanups: a } = this;
        for(const c in i){
            const l = i[c];
            if ("ref" === c) n = l;
            else if ("children" === c) r = l;
            else if (c.startsWith("attr:")) {
                const i = c.slice(5);
                (0, $cR8Yz.isSubscribable)(l) ? (0, $7hKUk.p)(a, (0, $cR8Yz.$attr)(this, i, l)) : (0, $2BOdQ.attr)(this, i, l);
            } else o[c] = l;
        }
        n && (0, $es6JP.setRef)(n, this), this.props = o, this.#t = r;
    }
    effect(t) {
        const s = this.#e;
        s && (0, $7hKUk.p)(s, t);
    }
    render() {
        throw new Error("You should implement `render` in your component subclass");
    }
    mount(t) {
        let s = this.#s;
        if (s) return s;
        this.#e = [];
        const e = this.#i, { shadowRootInit: i, formAssociated: n } = e, r = i.slotAssignment, o = this.shadowRoot ?? this.attachShadow({
            ...i,
            mode: "open"
        });
        n && (this.internals ??= this.attachInternals()), o.adoptedStyleSheets = [
            ...this.#i.styles
        ];
        const [a] = (0, $es6JP.mount)(this.render(), o);
        (0, $7hKUk.k)(this.cleanups, a);
        const h = this.#t;
        return h && ("manual" === r ? (0, $d0FcS.a)((0, $es6JP.mount), this, h, this.cleanups) : (0, $d0FcS.i)((0, $es6JP.mount), this, h, e.slotTag, this.cleanups), this.#t = void 0), s = this.#s = [
            ()=>this.unmount(),
            this,
            ()=>[
                    this,
                    this
                ]
        ], t?.(this), (0, $7hKUk.f)(this.#e, (t)=>(0, $7hKUk.k)(this.cleanups, t())), this.#e = null, s;
    }
    unmount() {
        this.#s && ((0, $7hKUk.y)(this.cleanups), this.cleanups.length = 0, this.shadowRoot.innerHTML = "", this.#s = void 0);
    }
};

});
parcelRegister("d0FcS", function(module, exports) {

$parcel$export(module.exports, "s", () => $978b3d3e6080305a$export$2408f22a0fab9ae5);
$parcel$export(module.exports, "a", () => $978b3d3e6080305a$export$407448d2b89b1813);
$parcel$export(module.exports, "i", () => $978b3d3e6080305a$export$23f2a1d2818174ef);

var $2BOdQ = parcelRequire("2BOdQ");

var $7hKUk = parcelRequire("7hKUk");
const $978b3d3e6080305a$export$2408f22a0fab9ae5 = (s)=>`${s}-slot`, $978b3d3e6080305a$var$c = (s, t, e)=>{
    (0, $2BOdQ.attr)(e, "slot", t), (0, $2BOdQ.appendChild)(s)(e);
}, $978b3d3e6080305a$var$p = (s, n)=>{
    if ((0, $7hKUk.C)(s)) (0, $7hKUk.p)(n, s);
    else if ((0, $7hKUk.q)(s)) for(let o = s.firstChild; o; o = o.nextSibling)$978b3d3e6080305a$var$p(o, n);
}, $978b3d3e6080305a$var$m = (s, n, o)=>{
    const t = [];
    if ((0, $7hKUk.j)(n)) $978b3d3e6080305a$var$p(n, t);
    else {
        const e = (s)=>{
            $978b3d3e6080305a$var$p(s, t);
        }, [i] = s(n, e);
        (0, $7hKUk.k)(o, i);
    }
    return t;
}, $978b3d3e6080305a$export$407448d2b89b1813 = (s, n, o, e)=>{
    (0, $7hKUk.f)(n.shadowRoot.querySelectorAll("slot"), (t)=>{
        const { name: r } = t;
        if (!(r in o)) return;
        const i = o[r];
        if (!i) return;
        const a = $978b3d3e6080305a$var$m(s, i, e);
        a.length && ((s, n, o)=>{
            s.append(...o), n.assign(...o);
        })(n, t, a);
    });
}, $978b3d3e6080305a$export$23f2a1d2818174ef = (n, o, t, e, r)=>{
    for(const i in t){
        const a = t[i];
        if (!a) continue;
        const f = $978b3d3e6080305a$var$m(n, a, r), l = (0, $2BOdQ.element)(e);
        l.append(...f), $978b3d3e6080305a$var$c(o, i, l);
    }
};

});


parcelRegister("duS9r", function(module, exports) {

$parcel$export(module.exports, "enableBuiltinSignals", () => $9d3815061d1a9511$export$de8fcbb66357c183);
$parcel$export(module.exports, "watch", () => $9d3815061d1a9511$export$3db5d71bdb2d5499);
$parcel$export(module.exports, "signal", () => $9d3815061d1a9511$export$e2ef10f86a8d60e8);
$parcel$export(module.exports, "effect", () => $9d3815061d1a9511$export$dc573d8a6576cdb3);
$parcel$export(module.exports, "computed", () => $9d3815061d1a9511$export$2983e091f1a1e8e2);

var $7hKUk = parcelRequire("7hKUk");

var $cR8Yz = parcelRequire("cR8Yz");

/**
 * @license MIT
 * Copyright (C) 2022  DarrenDanielDay <Darren_Daniel_Day@hotmail.com>
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ const $9d3815061d1a9511$var$h = CustomEvent, $9d3815061d1a9511$var$u = EventTarget, $9d3815061d1a9511$export$d95ec7aa9d3756d8 = "hyplate-signal-data", $9d3815061d1a9511$export$a9a36f4641f8c6f0 = (s)=>!!s?.[0, $7hKUk.z], $9d3815061d1a9511$export$c9f8b35cae62dd0f = (t)=>$9d3815061d1a9511$export$a9a36f4641f8c6f0(t) && t.proto === $9d3815061d1a9511$export$d4d09f95d8f6afca.prototype, $9d3815061d1a9511$var$l = (t)=>{
    const s = t.get.bind(t), r = Object.getPrototypeOf(t), e = Object.getOwnPropertyDescriptors(r);
    for(const r in e)if ("constructor" !== r) {
        const { value: n } = e[r];
        (0, $7hKUk.g)(n) && (s[r] = n.bind(t));
    }
    return Object.assign(s, t), s.proto = r, s;
};
let $9d3815061d1a9511$var$m = (0, $7hKUk.r);
const $9d3815061d1a9511$export$67779d284de59481 = (t)=>{
    $9d3815061d1a9511$var$m = t ?? (0, $7hKUk.r);
}, $9d3815061d1a9511$export$de8fcbb66357c183 = ()=>{
    (0, $cR8Yz.configureBinding)($9d3815061d1a9511$export$3db5d71bdb2d5499, $9d3815061d1a9511$export$a9a36f4641f8c6f0, $9d3815061d1a9511$export$68d8715fc104d294, $9d3815061d1a9511$export$c9f8b35cae62dd0f);
}, [$9d3815061d1a9511$var$w, $9d3815061d1a9511$var$v, $9d3815061d1a9511$var$f] = (0, $7hKUk.s)(), $9d3815061d1a9511$var$j = ()=>{
    const t = new Set;
    return $9d3815061d1a9511$var$w(t), [
        t,
        $9d3815061d1a9511$var$v
    ];
};
class $9d3815061d1a9511$export$d4d09f95d8f6afca {
    [(0, $7hKUk.z)] = !0;
    #t;
    #s;
    target = new $9d3815061d1a9511$var$u;
    constructor(t, s){
        this.#t = t, this.#s = s;
    }
    get() {
        return $9d3815061d1a9511$var$f()?.add(this), this.#t;
    }
    subscribe(t) {
        return (0, $7hKUk._)(this.target, $9d3815061d1a9511$export$d95ec7aa9d3756d8, $9d3815061d1a9511$var$S(t));
    }
    set(t) {
        (0, this.#s)(this.#t, t) || (this.#t = t, this.#r());
    }
    mutate(t) {
        t(this.#t), this.#r();
    }
    update(t) {
        this.set(t(this.#t));
    }
    #r() {
        $9d3815061d1a9511$var$z(this, this.#t);
    }
}
const $9d3815061d1a9511$export$e2ef10f86a8d60e8 = (t, s = $9d3815061d1a9511$var$m)=>$9d3815061d1a9511$var$l(new $9d3815061d1a9511$export$d4d09f95d8f6afca(t, s)), $9d3815061d1a9511$export$3db5d71bdb2d5499 = (t, s)=>{
    const r = t.subscribe(s);
    return s(t.get()), r;
}, $9d3815061d1a9511$export$68d8715fc104d294 = (t, s)=>t.set(s), $9d3815061d1a9511$export$dc573d8a6576cdb3 = (t)=>{
    let s, i = [];
    const n = ()=>{
        (0, $7hKUk.y)(i), s?.();
        const [e, c] = $9d3815061d1a9511$var$j();
        s = t(), c(), i = [
            ...e
        ].map((t)=>t.subscribe(n));
    };
    return n(), i.length ? ()=>{
        (0, $7hKUk.y)(i), s?.();
    } : s ?? (0, $7hKUk.n);
}, $9d3815061d1a9511$var$z = (t, s)=>{
    $9d3815061d1a9511$var$w(null), t.target.dispatchEvent(new $9d3815061d1a9511$var$h($9d3815061d1a9511$export$d95ec7aa9d3756d8, {
        detail: s
    })), $9d3815061d1a9511$var$v();
}, $9d3815061d1a9511$var$C = (0, $7hKUk.t)($9d3815061d1a9511$var$h);
class $9d3815061d1a9511$var$D {
    #e;
    constructor(t){
        this.#e = t;
    }
    handleEvent(t) {
        $9d3815061d1a9511$var$C(t) && t.type === $9d3815061d1a9511$export$d95ec7aa9d3756d8 && (0, this.#e)(t.detail);
    }
}
const $9d3815061d1a9511$var$S = (t)=>new $9d3815061d1a9511$var$D(t);
class $9d3815061d1a9511$export$293372c153fbbd93 {
    [(0, $7hKUk.z)] = !0;
    #i;
    #s;
    #t = null;
    #n = !0;
    #c = [];
    #a = 0;
    target = new $9d3815061d1a9511$var$u;
    constructor(t, s){
        this.#i = t, this.#s = s;
    }
    get() {
        if ($9d3815061d1a9511$var$f()?.add(this), !this.#n) return this.#t;
        this.#n = !1, (0, $7hKUk.y)(this.#c);
        const [t, s] = $9d3815061d1a9511$var$j(), e = this.#i, i = this.#t = e();
        return s(), this.#c = [
            ...t
        ].map((t)=>t.subscribe(this.#r)), i;
    }
    subscribe(t) {
        this.#a++;
        const r = (0, $7hKUk._)(this.target, $9d3815061d1a9511$export$d95ec7aa9d3756d8, $9d3815061d1a9511$var$S(t));
        return ()=>{
            r(), this.#a--, this.#a || this.#o();
        };
    }
    #r = ()=>{
        this.#n = !0;
        const t = this.#t, s = this.get();
        (0, this.#s)(t, s) || $9d3815061d1a9511$var$z(this, s);
    };
    #o() {
        (0, $7hKUk.y)(this.#c), this.#n = !0, this.#c = [], this.#t = null;
    }
}
const $9d3815061d1a9511$export$2983e091f1a1e8e2 = (t, s = $9d3815061d1a9511$var$m)=>$9d3815061d1a9511$var$l(new $9d3815061d1a9511$export$293372c153fbbd93(t, s));

});




//# sourceMappingURL=arcaea-toolbelt.21e32739.js.map
